import axios from './axios.js'
import url from './urls.js'

export default {
  ticket_query: ticket_id => axios.get(`${url.ticket_query}?ticket_id=${ticket_id}`),
  exchange_rate_query: () => axios.get(process.env.VUE_APP_EXCHANGE_RATE_ENDPOINT)
}
